module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('strong', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfront"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/acknowledgments#acknowledgments"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocpart"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/pt01#pt01"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART I:")]), _vm._v(" Sephardic Jewry in the Middle Ages: Origins, Development, and Flowering")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_vm._v("1 A Global Perspective on Sephardic and Mizrahi Jewry: An Introductory Essay")])]), _vm._v(" "), _c('p', {
    staticClass: "tocauthor"
  }, [_c('em', [_vm._v("Zion Zohar")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02"
    }
  }, [_vm._v("2 The Origins of Sephardic Jewry in the Medieval Arab World")])]), _vm._v(" "), _c('p', {
    staticClass: "tocauthor"
  }, [_c('em', [_vm._v("Mark R. Cohen")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 The Judeo-Arabic Heritage")])]), _vm._v(" "), _c('p', {
    staticClass: "tocauthor"
  }, [_c('em', [_vm._v("Norman A. Stillman")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Judeo-Spanish Culture in Medieval and Modern Times")])]), _vm._v(" "), _c('p', {
    staticClass: "tocauthor"
  }, [_c('em', [_vm._v("David M. Bunis")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Literatures of Medieval Sepharad")])]), _vm._v(" "), _c('p', {
    staticClass: "tocauthor"
  }, [_c('em', [_vm._v("Jonathan P. Decter")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Medieval Sephardic-Oriental Jewish Bible Exegesis: The Contributions of Saadia Gaon and Abraham ibn Ezra")])]), _vm._v(" "), _c('p', {
    staticClass: "tocauthor"
  }, [_c('em', [_vm._v("Isaac Kalimi")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Jewish Philosophy and Kabbalah in Spain")])]), _vm._v(" "), _c('p', {
    staticClass: "tocauthor"
  }, [_c('em', [_vm._v("Moshe Idel")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpart"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/pt02#pt02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART II:")]), _vm._v(" From Expulsion to the Modern Era: Exile, Decline, and Revival")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Hispanic Culture in Exile: Sephardic Life in the Ottoman Balkans")])]), _vm._v(" "), _c('p', {
    staticClass: "tocauthor"
  }, [_c('em', [_vm._v("Annette B. Fromm")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Sephardic Jurisprudence in the Recent Half-Millennium")])]), _vm._v(" "), _c('p', {
    staticClass: "tocauthor"
  }, [_c('em', [_vm._v("Zvi Zohar")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Safed Kabbalah and the Sephardic Heritage")])]), _vm._v(" "), _c('p', {
    staticClass: "tocauthor"
  }, [_c('em', [_vm._v("Morris M. Faierstein")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Jewish Women in the Ottoman Empire")])]), _vm._v(" "), _c('p', {
    staticClass: "tocauthor"
  }, [_c('em', [_vm._v("Paméla Dorn Sezgin")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpart"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/pt03#pt03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART III:")]), _vm._v(" Sephardic Jewry in the Modern Era and Special Topics")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Early Modern Sephardim and Blacks: Contact and Conflict between Two Minorities")])]), _vm._v(" "), _c('p', {
    staticClass: "tocauthor"
  }, [_c('em', [_vm._v("Jonathan Schorsch")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Diversity and Uniqueness: An Introduction to Sephardic Liturgical Music")])]), _vm._v(" "), _c('p', {
    staticClass: "tocauthor"
  }, [_c('em', [_vm._v("Mark Kligman")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 A Double Occlusion: Sephardim and the Holocaust")])]), _vm._v(" "), _c('p', {
    staticClass: "tocauthor"
  }, [_c('em', [_vm._v("Henry Abramson")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Sephardim and Oriental Jews in Israel: Rethinking the Sociopolitical Paradigm")])]), _vm._v(" "), _c('p', {
    staticClass: "tocauthor"
  }, [_c('em', [_vm._v("Zion Zohar")])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/contributors#contributors",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("About the Contributors")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocback"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0